export default "__VITE_ASSET__2a64aabf__"